import { useQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { GET_GLOBAL_CATEGORIES } from "../../graphql/org-gql";
import { ICategory, IGlobalCategoriesResponse, IOrg } from "../../types/org";
import { CheckIcon, CloseIcon } from "../common/icons";
import OrgTree from "../common/org-tree/org-tree";
import SpinnerOverlay from "../common/spinner/spinner";
import './style.scss';
import Button from "../common/button";

const OrgSelectionModal = (props: {
  isOpen: boolean,
  supportAll: boolean,
  toggle: () => void,
  onSelect: (org?: ICategory | IOrg) => void
}) => {
  const { isOpen, supportAll, toggle, onSelect } = props;

  const [selectedOrg, setSelectedOrg] = useState<ICategory | IOrg>();

  const { loading, error, data } = useQuery<IGlobalCategoriesResponse>(GET_GLOBAL_CATEGORIES)

  useEffect(() => setSelectedOrg(undefined), [isOpen]);

  const handleSelectAll = () => {
    onSelect(undefined);
    toggle();
  };

  const handleConfirm = useCallback(() => {
    onSelect(selectedOrg);
    toggle();
  }, [selectedOrg, onSelect, toggle]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} scrollable>
      <ModalHeader toggle={toggle} tag={'h2'}>Select Organization</ModalHeader>
      <ModalBody className="org-selector-panel">
        {loading && <SpinnerOverlay />}
        {error && <div className="alert alert-danger" role="alert"><small>Error loading organizations</small></div>}
        {!loading && !error &&
          <OrgTree roots={data?.globalCategories ?? []} onSelected={setSelectedOrg} isGlobal={true} selectOrgOnly={true} />
        }
      </ModalBody>
      <ModalFooter>
        {supportAll && <div className="flex-fill">
          <Button color="link" onClick={handleSelectAll}>Search in all</Button>
        </div>}

        <Button color="primary" onClick={handleConfirm} disabled={!selectedOrg}><CheckIcon /> Select</Button>
        <Button color="secondary" onClick={toggle}><CloseIcon /> Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrgSelectionModal;
